// extracted by mini-css-extract-plugin
export var button = "_6n-4";
export var hasDarkBackground = "_6n-7";
export var hasLightBackground = "_6n-6";
export var iconWrapper = "_6n-0";
export var large = "_6n-2";
export var medium = "_6n-1";
export var small = "_6n-5";
export var xsmall = "_6n-3";